//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter)
//引用页面
import bazaar from '@/views/bazaar.vue';
import task from '@/views/task.vue';
import basket from '@/views/basket.vue';
import order from '@/views/order.vue';
import offer from '@/views/offer.vue';
import help from '@/views/help.vue';
import ex from '@/views/ex.vue';


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

//定义routes路由的集合，数组类型
const routes=[
    //单个路由均为对象类型，path代表的是路径，component代表组件
    {path:'/bazaar',name :'bazaar',component:bazaar},
    {path:"/task",component:task},
    {path:"/basket",component:basket},
    {path:"/order",component:order},
    {path:"/offer",name :'offer',component:offer},
    {path:"/help",name :'help',component:help},
    {path:"/ex",name :'ex',component:ex},
    //写个路径为空的路由
    {path:"",redirect: '/bazaar'}    
]

//实例化VueRouter并将routes添加进去
const router=new VueRouter({
//ES6简写，等于routes：routes
    routes,
});

//抛出这个这个实例对象方便外部读取以及访问
export default router



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js